// extracted by mini-css-extract-plugin
export default {"reparatur-page":"Index_reparatur-page__kMO2m"};